import {
  GLOBAL_PROPS_KEY,
  ERROR_SEVERITY_TEXT,
  ERROR_SEVERITY
} from '../constants/constants';

export const asyncQuery = async (client, query, vars) => {
  try {
    const { data } = await client.query({
      query: query,
      variables: vars,
      fetchPolicy: 'network-only',
      skip: true
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCache = (client, query, fieldName) => {
  let retData = '';

  try {
    retData = client.readQuery({
      query: query
    });
  } catch (err) {
    // not in cache, look in session
    const sessionData = sessionStorage.getItem(fieldName);

    if (sessionData) {
      // got it from session storage, write it to the Apollo cache
      retData = JSON.parse(sessionData);
      client.writeQuery({
        query: query,
        data: retData
      });
    }
  }
  return retData;
};

export const parseErrors = errors => {
  // We'll take the error structure returned and flatten it for easier use
  //
  // Error reponse will be an object with the following structure:
  // severity - this will be the higest severity error found (Error -> Warning -> Info -> None)
  // errors - array for all the error statuses
  // warnings - array for all the warnings
  // info - array with info ones
  const errResponse = {
    severity: ERROR_SEVERITY['None'],
    errors: [],
    warnings: [],
    info: []
  };

  if (!errors) return errResponse;

  errors.forEach(error => {
    const { data } = error.extensions;
    const resp = {
      message: error.message,
      severity: data.severity,
      code: data.code,
      text: data.text
    };

    if (ERROR_SEVERITY[data.severity] > errResponse.severity) {
      errResponse.severity = ERROR_SEVERITY[data.severity];
    }
    switch (data.severity) {
      case ERROR_SEVERITY_TEXT.ERROR:
        errResponse.errors.push(resp);
        break;
      case ERROR_SEVERITY_TEXT.WARNING:
        errResponse.warnings.push(resp);
        break;
      default:
        //INFO
        errResponse.info.push(resp);
    }
  });

  return errResponse;
};

export const getSession = key => {
  return sessionStorage.getItem(key);
};

export const setSession = (key, val) => {
  sessionStorage.setItem(key, JSON.stringify(val));
};

// I know these seem redundant here but the idea is that the component that needs the global props (reference data)
// doesn't care where they are coming from, and the implementation could possibly change in the future.
export const getGlobalProps = () => {
  return JSON.parse(getSession(GLOBAL_PROPS_KEY));
};
export const setGlobalProps = val => {
  setSession(GLOBAL_PROPS_KEY, val);
};

// Assuming the structure of the sort object based on our use of DevExpress
// (https://devexpress.github.io/devextreme-reactive/react/grid/docs/reference/sorting-state/)
export const buildSortCriteriaForDSL = (sort, dataColumns) => {
  if (!sort || !dataColumns) {
    return null;
  }

  const formattedSortItems = sort.map(s => {
    // Find the sorted column from the column definition
    const column = dataColumns.find(c => {
      return c.name === s.columnName;
    });
    // Return the correct sort name based on the column definition.
    // The name has to match the GraphQL definition on the backend.
    return `${column.sortName || column.name} ${s.direction}`;
  });

  const sortString = `order by ${formattedSortItems.join(', ')}`;
  return sortString;
};
